<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.form" 
      persistent
      scrollable
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          Konfirmasi Pembayaran
        </v-card-title>
        <v-card-text style="height: 650px;" class="pt-5">
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <ValidationProvider name="Bank" rules="required" v-slot="{ errors }">
                <v-select
                  style="width: 60%;"
                  dense
                  outlined
                  single-line
                  label="Bank"
                  :color="style.primary"
                  :items="master"
                  item-value="bank_id"
                  item-text="bank_name"
                  item-color="light-green lighten-2"
                  v-model="form.bank"
                  :error-messages="errors"
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                   <template v-slot:selection="data">
                    <v-avatar left tile class="mr-2">
                      <v-img contain :src="data.item.ref_bank_image"></v-img>
                    </v-avatar>
                    {{ data.item.bank_name }}
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile>
                        <v-img contain :src="data.item.ref_bank_image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.bank_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </ValidationProvider>
              <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                <v-text-field 
                  dense
                  outlined
                  label="Nama Pemilik"
                  :color="style.primary"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="No Rekening" rules="required" v-slot="{ errors }">
                <v-text-field 
                  style="width: 75%;"
                  type="number"
                  dense
                  outlined
                  label="No Rekening"
                  :color="style.primary"
                  v-model="form.number"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <p class="caption mb-2">
                <b>Bukti Pembayaran</b>
              </p>
              <v-img 
                contain
                width="200"
                height="200"
                min-height="200"
                alt="property"
                style="border-radius: 20px;"
                gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
                :src="form.image === '' ? require('@/assets/image/no-image-available.jpg') : form.image">
                <image-input v-model="images">
                  <div slot="activator">
                    <v-btn
                      rounded
                      block
                      color="#000"
                      class="text-capitalize white--text"
                      elevation="0"
                      style="position: absolute; bottom: 0px; width: 100%; opacity: 50%;">
                      <v-icon color="white" class="cursor-pointer mr-2">mdi-camera-outline</v-icon> Unggah Gambar
                    </v-btn>
                  </div>
                </image-input>
              </v-img>

              <quill-editor 
                class="mt-8 mb-12"
                ref="myTextEditor"
                :options="option"
                v-model="form.note">
              </quill-editor>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-text class="py-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            :loading="process.payment"
            :disabled="process.payment"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            small
            color="red"
            class="text-capitalize red--text"
            :disabled="process.payment"
            @click="reset(); $refs.observer.reset();">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.success"
      width="650"
      overlay-opacity="0.7"
      persistent>
      <v-card 
        color="#f3f3f3"
        class="border-radius">
        <v-row class="ma-0" justify="center" align="center">
          <v-col :cols="$vuetify.breakpoint.name !== 'xs' ? 6 : 12" class="pa-0">
            <v-card
              flat
              min-height="325"
              class="border-radius pa-2">
              <v-card-text class="pa-0 text-right" v-if="$vuetify.breakpoint.name === 'xs'">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  class="background-default white--text"
                  @click="dialog.success = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-text>
              <div class="pa-5" :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0' : ''">
                <div class="d-flex align-center mb-5">
                  <v-divider color="white"></v-divider>
                  <div class="mx-1 font-weight-bold text-second">BERHASIL</div>
                  <v-divider color="white"></v-divider>
                </div>
                <div class="d-flex justify-center mt-8">
                  <div class="sa">
                    <div class="sa-success">
                      <div class="sa-success-tip"></div>
                      <div class="sa-success-long"></div>
                      <div class="sa-success-placeholder"></div>
                      <div class="sa-success-fix"></div>
                    </div>
                  </div>
                </div>
                <div class="text-center body-2 text-second line-text-first mb-8">
                  {{ success.message }}
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6" class="pa-12" v-if="$vuetify.breakpoint.name !== 'xs'">
            <v-btn
              style="position: absolute; top: 8px; right: 8px;"
              fab
              x-small
              elevation="0"
              class="background-default white--text"
              @click="dialog.success = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-img alt="sodapos"
              contain
              :src="require('@/assets/logo/logo.png')">
            </v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="12">
        <v-card
          class="border-radius box-shadow">
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="3">
                <v-select
                  dense
                  outlined
                  :items="items.project"
                  item-text="project_name"
                  item-value="project_id"
                  item-color="light-green lighten-2"
                  v-model="filter.project_id"
                  label="Proyek"
                  :color="style.primary"
                  hide-details>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="5" v-if="$vuetify.breakpoint.name === 'lg'"></v-col>
              <v-col cols="12" md="4" class="d-flex">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Cari Tagihan . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider class="mx-4"/>

          <v-card-text class="py-0" style="min-height: 700px;">
            <v-skeleton-loader
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table-tbody">
              <div>
                <v-simple-table>
                  <template v-slot:default>
                    <thead v-if="!process.run && list.length > 0">
                      <tr>
                        <th class="text-left pl-0">Nomor Tagihan</th>
                        <th class="text-left" width="300">Nama Proyek</th>
                        <th class="text-left">Kategori</th>
                        <th class="text-right">Nominal</th>
                        <th class="text-left">Jatuh Tempo</th>
                        <th class="text-left">Dibayarkan</th>
                        <th class="text-right">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in list" 
                        :key="index">
                        <td class="text-second pl-0">
                          {{ item.invoice_number }}
                        </td>
                        <td class="text-second text-capitalize">
                          {{ item.project_name }}
                        </td>
                        <td class="text-second text-capitalize">
                          {{ item.project_category_name }}
                        </td>
                        <td class="text-second text-capitalize text-right">
                          {{ parseInt(item.invoice_price) | price }}
                        </td>
                        <td class="red--text text-capitalize">
                          <span v-if="item.invoice_due_date === ''">
                            -
                          </span>
                          <span v-else>
                            {{ item.invoice_due_date | datetime }}
                          </span>
                        </td>
                        <td class="teal--text text-capitalize">
                          <span v-if="item.invoice_confirmation_datetime === ''">
                            -
                          </span>
                          <span v-else>
                            {{ item.invoice_confirmation_datetime | datetime }}
                          </span>
                        </td>
                        <td class="text-right pr-0">
                          <div v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
                            <v-btn
                              v-if="item.invoice_status === 'waiting'"
                              small
                              elevation="3"
                              :color="style.primary"
                              class="text-capitalize white--text"
                              :disabled="process.payment"
                              @click="reset(item)">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Konfirmasi Sekarang
                            </v-btn>

                            <span v-if="item.invoice_status !== 'waiting'"
                              class="text-capitalize font-weight-bold d-flex align-center justify-end"
                              :class="item.invoice_status === 'confirmed' ? 'orange--text' : item.invoice_status === 'approved' ? 'teal--text' : 'red--text'">
                              <v-icon small class="mr-1"
                                :color="item.invoice_status === 'confirmed' ? 'orange' : item.invoice_status === 'approved' ? 'teal' : 'red'">
                                {{ item.invoice_status === 'confirmed' ? 'mdi-credit-card-clock-outline' : item.invoice_status === 'approved' ? 'mdi-credit-card-check-outline' : 'mdi-credit-card-remove-outline' }}
                              </v-icon>
                              {{ item.invoice_payment_status_label }}
                            </span>
                          </div>

                          <div v-if="!user.user_company_roles_name.includes('superuser') && !user.user_company_roles_name.includes('administrator')">
                            <span v-if="item.invoice_status !== 'waiting'"
                              class="text-capitalize font-weight-bold d-flex align-center justify-end"
                              :class="item.invoice_status === 'confirmed' ? 'orange--text' : item.invoice_status === 'approved' ? 'teal--text' : 'red--text'">
                              <v-icon small class="mr-1"
                                :color="item.invoice_status === 'confirmed' ? 'orange' : item.invoice_status === 'approved' ? 'teal' : 'red'">
                                {{ item.invoice_status === 'confirmed' ? 'mdi-credit-card-clock-outline' : item.invoice_status === 'approved' ? 'mdi-credit-card-check-outline' : 'mdi-credit-card-remove-outline' }}
                              </v-icon>
                              {{ item.invoice_payment_status_label }}
                            </span>
                          </div>

                          <!-- JIKA MASUK SEBAGAI SUPERUSER ATAU ADMINISTRATOR -->
                          <!-- <div v-if="user.role === 'superuser' || user.role === 'administrator'">
                            <v-btn
                              v-if="item.invoice_payment_status === ''"
                              small
                              elevation="3"
                              color="#4FC3F7"
                              class="text-capitalize white--text"
                              :disabled="process.payment"
                              :loading="process.payment && form.invoice_number === item.invoice_number"
                              @click="form.invoice_number = item.invoice_number; payment(item.invoice_number);">
                              <v-icon small class="mr-1">mdi-check</v-icon>
                              Bayar Sekarang
                            </v-btn>

                            <v-btn
                              v-if="item.invoice_payment_status !== '' && item.invoice_payment_status === 'expire'"
                              color="orange"
                              small
                              elevation="0"
                              class="text-capitalize white--text"
                              :loading="process.payment && form.invoice_number === item.invoice_number"
                              :disabled="process.payment"
                              @click="form.invoice_number = item.invoice_number; payment(item.invoice_number)">
                              <v-icon small class="mr-1">mdi-credit-card-refresh-outline</v-icon>
                              Expired Bayar Ulang
                            </v-btn>

                            <span v-if="item.invoice_payment_status !== '' && item.invoice_payment_status !== 'pending' && item.invoice_payment_status !== 'expire'"
                              class="text-capitalize font-weight-bold d-flex align-center justify-end"
                              :class="item.invoice_payment_status === 'settlement' ? 'teal--text' : 'red--text'">
                              <v-icon small class="mr-1"
                                :color="item.invoice_payment_status === 'settlement' ? 'teal' : 'red'">
                                {{ item.invoice_payment_status === 'settlement' ? 'mdi-credit-card-check-outline' : 'mdi-credit-card-remove-outline' }}
                              </v-icon>
                              {{ item.invoice_payment_status_label }}
                            </span>

                            <div v-if="item.invoice_payment_status !== '' && item.invoice_payment_status === 'pending'">
                              <v-tooltip top v-if="item.invoice_payment_instruction !== ''">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    color="#4FC3F7"
                                    min-width="30"
                                    class="text-capitalize mr-1"
                                    v-bind="attrs"
                                    v-on="on"
                                    :href="item.invoice_payment_instruction"
                                    target="_blank">
                                    <v-icon>mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>Cara Pembayaran</span>
                              </v-tooltip>

                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    outlined
                                    color="orange"
                                    min-width="30"
                                    class="text-capitalize"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    :loading="process.payment && form.invoice_number === item.invoice_number"
                                    :disabled="process.payment"
                                    @click="form.invoice_number = item.invoice_number; payment(item.invoice_number)">
                                    <v-icon small class="mr-1">mdi-credit-card-refresh-outline</v-icon>
                                    {{ item.invoice_payment_status_label }}
                                  </v-btn>
                                </template>
                                <span>Ganti Metode Pembayaran</span>
                              </v-tooltip>
                            </div>
                          </div> -->

                          <!-- JIKA MASUK TIDAK SEBAGAI SUPERUSER ATAU ADMINISTRATOR -->
                          <!-- <div v-if="user.role !== 'superuser' && user.role !== 'administrator'">
                            <span
                              class="text-capitalize font-weight-bold d-flex align-center justify-end"
                              :class="item.invoice_payment_status === 'pending' ? 'orange--text' : item.invoice_payment_status === 'settlement' ? 'teal--text' : 'red--text'">
                              <v-icon small class="mr-1"
                                :color="item.invoice_payment_status === 'pending' ? '#7B7B7B' : item.invoice_payment_status === 'settlement' ? 'teal' : 'red'">
                                {{ item.invoice_payment_status === 'pending' ? 'mdi-credit-card-clock-outline' : item.invoice_payment_status === 'settlement' ? 'mdi-credit-card-check-outline' : 'mdi-credit-card-remove-outline' }}
                              </v-icon>
                              {{ item.invoice_payment_status_label }}
                            </span>
                          </div> -->
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-skeleton-loader>

            <div class="d-flex text-center text--secondary my-16 py-16" style="min-height: 550px;" v-if="!process.run && pagination.total_page < 1">
              <v-img 
                class="my-16 py-16"
                contain
                width="200"
                height="200"
                :src="require('../../../assets/404/404.svg')">
              </v-img>
            </div>
            <v-divider/>
          </v-card-text>

          <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Catatan'
        },
        dialog: {
          form: false,
          success: false
        },
        selected: {
          pagination: 1
        },
        filter: {
          title: '',
          project_id: ''
        },
        items: {
          project: [],
          unit: []
        },
        master: [],
        headers: [],
        list: [],
        pagination: {},
        images: {
          url: ''
        },
        form: {
          invoice_id: '',
          bank: '',
          name: '',
          number: '',
          image: '',
          note: ''
        },
        process: {
          run: false,
          payment: false
        },
        success: {
          message: ''
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'filter.project_id': function(val) {
        this.fetchUnit()
        this.fetch()
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      },
      images: {
        handler: function () {
          if (this.images) {
            this.form.image = this.images.url
          }
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
      this.fetchProject()
      this.bank()
    },
    methods: {
      async fetchProject() {
        await get(`auth/company/project/list-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.items.project = [{
              project_id: 0,
              project_name: 'Semua'
            }]

            let p = res.data.results

            for (let i in p) {
              this.items.project.push(p[i])
            }
          }
        })
      },
      async fetchUnit() {
        await get(`auth/company/project/unit-type/list-option`, {
          params: {
            project_id: this.filter.project_id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.items.unit = [{
              unit_type_id: 0,
              unit_type_name: 'Semua'
            }]

            let p = res.data.results

            for (let i in p) {
              this.items.unit.push(p[i])
            }
          }
        })
      },
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          project_id: this.filter.project_id,
          order: 'invoice_created_datetime',
          sort: 'DESC',
          filter: [
            {
              type: 'string',
              field: 'invoice_number',
              value: this.filter.title,
              comparison: '<>'
            }
          ]
        }
        await get(`auth/invoice/list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          } else if (res.status === 400 && res.error_code === "error_failed") {
            this.process.run = false
            this.$router.push({ path: '/404' }) // Redirect to 404 page
          }
        })
        .catch((error) => {
          this.process.run = false
          this.$router.push({ path: '/404' }) // Redirect to 404 page on error
        })
      },
      async bank() {
        await get(`site/bank/list`, {
          params: {
            limit: 1000
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.master = res.data.results
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false
        
        this.form = { 
          invoice_id: item !== undefined ? item.invoice_id : '',
          bank: '',
          name: '',
          number: '',
          image: '',
          note: ''
        }

        this.process.payment = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.payment = true

          await post(`auth/invoice/confirmation`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.process.payment = false
              this.dialog.form = false
              this.dialog.success= true
              
              this.success.message = 'Pembayaran anda berhasil, silahkan menunggu konfirmasi dari admin kami.'

              this.fetch()
            } else {
              this.process.payment = false
              this.error.message = res.msg
            }
          })
        }
      },
      // PAYMENT GATEWAY BELUM DIGUNAKAN
      async payment(invoice) {
        let self = this
        this.process.payment = true

        let params = {
          invoice_number: invoice
        }

        await get(`auth/invoice/get-snap-token`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.payment = false
            this.form.invoice_number = ''
            
            // SNAP MIDTRANS
            snap.pay(res.data.token, {
              onSuccess: function (result) {
                self.dialog.success = true
                self.success.message = 'Pembayaran anda telah masuk ke sistem, silahkan menunggu konfirmasi dari MiPRO.'

                self.fetch()
              },
              onPending: function (result) {
                self.callback(invoice, result)
              },
              onError: function(result){
                self.dialog.success = true
                self.success.message = 'Terjadi kesalahan pada pembayaran anda ke MiPRO, silahkan coba kembali.'

                self.fetch()
              }
            })
          }
        })
      },
      async callback(invoice, midtrans) {
        await post(`auth/invoice/update-invoice-data-payment`, {
          data: {
            invoice_number: invoice,
            invoice_payment_data: JSON.stringify(midtrans)
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            console.log(res)
            this.dialog.success = true
            this.success.message = 'Silahkan melakukan konfirmasi pembayaran untuk mendapatkan layanan dari MiPRO.'

            this.fetch()
          }
        })
      }
    }
  }
</script>

<style>
tr:hover {
  cursor: pointer;
  background-color: white !important;
}
.table-report table > thead > tr > th {
  position: sticky !important;
  z-index: 1;
  top: 0;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(1) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 0; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(2) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 200px; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > thead > tr > th:nth-child(6) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 320px; 
  z-index: 2 !important;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(1) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 0; 
  z-index: 1;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(2) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 200px; 
  z-index: 1;
  background: white;
}
.table-report  table > tbody > tr > td:nth-child(6) {
  position: sticky !important; 
  position: -webkit-sticky !important; 
  left: 320px; 
  z-index: 1;
  background: white;
}
</style>

<style lang="scss">
.sa {
  width: 140px;
  height: 140px;
  padding: 26px;
  background-color: #fff;
  &-success {
    border-radius: 50%;
    border: 4px solid var(--color-primary);
    box-sizing: content-box;
    height: 80px;
    padding: 0;
    position: relative;
    background-color: #fff;
    width: 80px;
    &:after, &:before {
      background: #fff;
      content: '';
      height: 120px;
      position: absolute;
      transform: rotate(45deg);
      width: 60px;
    }
    &:before {
      border-radius: 40px 0 0 40px;
      width: 26px;
      height: 80px;
      top: -17px;
      left: 5px;
      transform-origin: 60px 60px;
      transform: rotate(-45deg);
    }
    &:after {
      border-radius: 0 120px 120px 0;
      left: 30px;
      top: -11px;
      transform-origin: 0 60px;
      transform: rotate(-45deg);
      animation: rotatePlaceholder 4.25s ease-in;
    }
    &-placeholder {
      border-radius: 50%;
      border: 4px solid rgb(230 246 254 / 75%);
      box-sizing: content-box;
      height: 80px;
      left: -4px;
      position: absolute;
      top: -4px;
      width: 80px;
      z-index: 2;
    }
    &-fix {
      background-color: #fff;
      height: 90px;
      left: 28px;
      position: absolute;
      top: 8px;
      transform: rotate(-45deg);
      width: 5px;
      z-index: 1;
    }
    &-tip, &-long {
      background-color: var(--color-primary);
      border-radius: 2px;
      height: 5px;
      position: absolute;
      z-index: 2;
    }
    &-tip {
      left: 14px;
      top: 46px;
      transform: rotate(45deg);
      width: 25px;
      animation: animateSuccessTip .75s;
    }
    &-long {
      right: 8px;
      top: 38px;
      transform: rotate(-45deg);
      width: 47px;
      animation: animateSuccessLong .75s;
    }
  }
}
@keyframes animateSuccessTip {
  0%, 54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0%, 65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0%, 5% {
    transform: rotate(-45deg);
  }
  100%, 12% {
    transform: rotate(-405deg);
  }
}
</style>